/*
Copied and adapted from https://github.com/Esri/react-arcgis/blob/master/src/ts/index.ts

Copyright © 2017-2019 Esri

Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on
an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the
specific language governing permissions and limitations under the License.

A copy of the license is available in the repository's LICENSE file.
*/
import * as GeoMap from "./components/map/map";
import * as GeoScene from "./components/scene/scene";
import * as GeoWebMap from "./components/web-map/web-map";
import * as GeoWebScene from "./components/web-scene/web-scene";

const Geo = {
    Map: GeoMap.Map,
    Scene: GeoScene.Scene,
    WebMap: GeoWebMap.WebMap,
    WebScene: GeoWebScene.WebScene
};

export default Geo;

export const WebMap = GeoWebMap.WebMap;
export const WebScene = GeoWebScene.WebScene;
export const Map = GeoMap.Map;
export const Scene = GeoScene.Scene;
